
export const SessionStorage = {
  set: (token: string, value: string) => sessionStorage.setItem(token, value),
  get: (token: string) => sessionStorage.getItem(token),
  getObject: (token: string) => typeof window !== "undefined" && JSON.parse(sessionStorage.getItem(token) ?? "{}"),

  setObject: (token: string, value: string | Object | undefined) => sessionStorage.setItem(token, JSON.stringify(value)),
  remove: (token: string) => sessionStorage.removeItem(token),
  clear: () => sessionStorage.clear()
}

export const LocalStorage = {
  set: (key: string, value: string) => localStorage.setItem(key, value),
  get: (key: string) => localStorage.getItem(key),
  getObject: (key: string) => typeof window !== "undefined" && JSON.parse(localStorage.getItem(key) ?? "{}"),
  setObject: (key: string, value: string | Object | undefined) => localStorage.setItem(key, JSON.stringify(value)),
  remove: (key: string) => localStorage.removeItem(key),
}
